// One way of writing out a list of devices, used by everything that has room
// for a line rather than a table: the object's Info card, the work order, the
// calendar tooltip and the work-order list.
//
// "Immergas EXA (sn 3-4567), WSTB300" — the name is what the office calls it,
// the serial number is what tells two of the same boiler apart, and a device
// without one simply has none.
export function deviceSummary (devices) {
  return (devices || [])
    .map(device => device.name + (device.serial ? ' (sn ' + device.serial + ')' : ''))
    .join(', ')
}

export default { deviceSummary }
